import { Injectable } from '@angular/core';
import { LeaveTypeModel } from './model/leave-type.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LeaveTypeService {

  constructor(private http: HttpClient) { }

  getLeaveTypeList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/' + environment.app + '/leave-type/get', requestData);
  }

  getLeaveTypeById(id: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/' + environment.app + '/leave-type/get/' + id, '');
  }

  update(leaveTypeInfo: LeaveTypeModel): Observable<any> {
    if (leaveTypeInfo.hasOwnProperty("id") && leaveTypeInfo.id && leaveTypeInfo.id !== 0) {
      return this.http.post(environment.baseUrl + '/' + environment.app + '/leave-type/update', leaveTypeInfo);
    } else {
      return this.http.post(environment.baseUrl + '/' + environment.app + '/leave-type/add', leaveTypeInfo);
    }
  }

  delete(leaveTypeInfo: LeaveTypeModel): Observable<any> {
    return this.http.post(environment.baseUrl + '/' + environment.app + '/leave-type/delete/' + leaveTypeInfo.id, leaveTypeInfo);
  }
}
